import React from 'react';
import HelpIcon from './HelpIcon';

const RadioGroupInput = ({
  label,
  name,
  options,
  register,
  errors,
  validation,
  align = 'left',
  sx = {},
  showRequiredIndicator = false,
  helptext
}) => (
  <div className="form-group radio-group" style={{ textAlign: align }}>
    <p>
      {label}
      {validation?.required && showRequiredIndicator && <span className="required-indicator">*</span>}
      <HelpIcon helptext={helptext} />
    </p>
    {options.map((opt, idx) => (
      <label key={idx}>
        <input
          key={`radgrp_${idx}`}
          type="radio"
          value={opt.value}
          style={opt.sx || sx}
          {...register(name, validation)}
        />
        {opt.label}
      </label>
    ))}
    {errors[name] && <p style={{ color: 'red' }}>{errors[name].message}</p>}
  </div>
);

export default RadioGroupInput;
